// 2026-06-23 (ADR-015 D8) — translates the engineer-facing `MoneyMovement` enum (the generic
// content scanner's per-row suggestion) into treasurer-first display labels at
// the preview row-grid render boundary. Sibling of `expenditureCategoryLabel` /
// `aliasResolutionLabels`: a pure, React-free map so it can be reused across
// packages and snapshot-tested cheaply. Per `feedback_treasurer_first_copy.md`
// the enum identifier never renders verbatim; the money-movement words
// (received/spent/refund/void/pending/fee) are already the treasurer-facing
// vocabulary, so most labels are the word itself — `Void` reads "Void /
// reversed" to match the scanner's voided/reversed token set.

import { MoneyMovement } from '../generated/enums.gen';

/**
 * Per-movement treasurer-first label. Exported so the snapshot test can pin the
 * literals; a new `MoneyMovement` member without an entry surfaces as a compile
 * error (the `Record` is keyed by the enum).
 */
export const MONEY_MOVEMENT_LABELS: Readonly<Record<MoneyMovement, string>> = {
  [MoneyMovement.Received]: 'Received',
  [MoneyMovement.Spent]: 'Spent',
  [MoneyMovement.Refund]: 'Refund',
  [MoneyMovement.Void]: 'Void / reversed',
  [MoneyMovement.Pending]: 'Pending',
  [MoneyMovement.Fee]: 'Fee',
};

/**
 * Resolves the treasurer-first display label for a suggested `MoneyMovement`.
 * Takes the raw wire string (the preview ships `sampleRowMovements: string[]`)
 * and passes any unmapped value through unchanged — never empty, never throws
 * — so a future enum member added server-side degrades gracefully instead of
 * crashing the preview route (`project_wire_enum_pascalcase_discriminators`).
 */
export function moneyMovementLabel(value: string): string {
  return MONEY_MOVEMENT_LABELS[value as MoneyMovement] ?? value;
}
